import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=391accd6&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391accd6",
  null
  
)

export default component.exports